import { DefaultService } from '@/services/DefaultService';

export default class GrupoEconomicoService extends DefaultService {
    constructor(http, router, env) {
        super(http, router, env);
    }

    updateSituacao(grupoeconomico) {
        return this._http
            .post(`${this._env}/agro/grupo-economico/updatesituacao`, grupoeconomico, this._headers)
            .then(
                (res) => {
                    return res.body;
                },
                (err) => {
                    this.verifyError(err);
                    throw err;
                }
            );
    }

    findAll(column, order, page, limit, situacao, ...params) {
        return this._http
            .get(
                encodeURI(
                    `${this._env}/agro/grupo-economico.json?page=${page}&limit=${limit}&column=${column}&order=${order}&situacao=${situacao}&param=${params}`
                ),
                this._headers
            )
            .then(
                (res) => {
                    return res.body;
                },
                (err) => {
                    this.verifyError(err);
                    throw new Error('Problems while jobs are loading');
                }
            );
    }

    findAllCombo(...params) {
        return this._http
            .get(
                encodeURI(`${this._env}/agro/grupo-economico/getcombo.json?param=${params}`),
                this._headers
            )
            .then(
                (res) => {
                    return res.body;
                },
                (err) => {
                    this.verifyError(err);
                    throw new Error('Problems while jobs are loading');
                }
            );
    }

    find(id) {
        return this._http.get(`${this._env}/agro/grupo-economico/${id}.json`, this._headers).then(
            (res) => {
                return res.body;
            },
            (err) => {
                this.verifyError(err);
                throw new Error('Problems while jobs are loading');
            }
        );
    }

    save(form) {
        return this._http.post(`${this._env}/agro/grupo-economico`, form, this._headers).then(
            (res) => {
                return res.body;
            },
            (err) => {
                this.verifyError(err);
                throw err;
            }
        );
    }
}
